import { render } from "./FullGame.vue?vue&type=template&id=f361a04a"
import script from "./FullGame.vue?vue&type=script&lang=js"
export * from "./FullGame.vue?vue&type=script&lang=js"

import "./FullGame.vue?vue&type=style&index=0&id=f361a04a&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__